import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/metric';
import {
  startLoading,
  stopLoading
} from '../actions/settings/loading';
import { modalErrorOpen } from '../actions/modalError';
import { post, get } from '../../utils/api';

// Получение списка типов метрик
export function* metricPieceTypesList({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      get,
      '/metrics/piece/types'
    );
    yield put(actions.metricPieceTypesListSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Получение данных метрики приемки
export function* metricPieceData({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      post,
      `/metrics/piece/{metrics}?metrics=${payload.metricId}`,
      {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
        plantIds: payload.plantIds
      }
    );
    yield put(actions.metricPieceDataSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Получение данных метрики приемки / сводно
export function* metricPieceDataAll({ payload }) {
  try {
    yield put(startLoading());
    const response = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 5; i++) {
      response[i] = yield call(
        post,
        `/metrics/piece/{metrics}?metrics=${i + 1}`,
        {
          dateFrom: payload.dateFrom,
          dateTo: payload.dateTo,
          plantIds: payload.plantIds
        }
      );
      response[i].metricId = i + 1;
    }
    yield put(actions.metricPieceDataAllSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Получение метрики активности / сводно
export function* metricUserActivityShort({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      post,
      '/metrics/user-activity/short',
      {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo
      }
    );
    yield put(actions.metricUserActivityShortSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Получение метрики активности / детально
export function* metricUserActivityDetailed({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      post,
      `/metrics/user-activity/detailed/{metrics}?metrics=${payload.code}`,
      {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo
      }
    );
    yield put(actions.metricUserActivityDetailedSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

/** Получение складов созданных за период с dateFrom по DateTo */
export function* metricAddedStocks({ payload }) {
  try {
    yield put(stopLoading());
    const response = yield call(
      post,
      '/metrics/piece/added-stocks',
      {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo
      }
    );
    yield put(actions.metricAddedStocksSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}
